module.exports = __webpack_public_path__ + "static/media/PDF_87.b673a16e.pdf";